__turbopack_context__.v({
  "pickup-info": "pickup-info-component-module-scss-module__g9GiCa__pickup-info",
});
